var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersonalInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.25 7C7.90279 7 6 8.90279 6 11.25C6 13.5972 7.90279 15.5 10.25 15.5C12.5972 15.5 14.5 13.5972 14.5 11.25C14.5 8.90279 12.5972 7 10.25 7ZM5.5 11.25C5.5 8.62665 7.62665 6.5 10.25 6.5C12.8734 6.5 15 8.62665 15 11.25C15 13.8734 12.8734 16 10.25 16C7.62665 16 5.5 13.8734 5.5 11.25Z",
    fill: "#2D2943"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.25 18C7.47304 18 4.98911 19.0253 3.29758 20.6392C1.92366 21.9501 1.07494 23.6457 1.00473 25.5H19.4953C19.3824 22.5261 17.2627 19.9513 14.1902 18.7367C12.9957 18.2645 11.6603 18 10.25 18ZM2.95242 20.2775C4.74237 18.5697 7.35217 17.5 10.25 17.5C11.7228 17.5 13.1206 17.7762 14.374 18.2717C17.6772 19.5775 20 22.4204 20 25.75V26H0.5V25.75C0.5 23.644 1.43162 21.7285 2.95242 20.2775Z",
    fill: "#2D2943"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8843 20.3718C10.8843 20.7206 10.6015 21.0034 10.2527 21.0034C9.90386 21.0034 9.62109 20.7206 9.62109 20.3718C9.62109 20.023 9.90386 19.7402 10.2527 19.7402C10.6015 19.7402 10.8843 20.023 10.8843 20.3718Z",
    fill: "#2D2943"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8843 23.1316C10.8843 23.4804 10.6015 23.7632 10.2527 23.7632C9.90386 23.7632 9.62109 23.4804 9.62109 23.1316C9.62109 22.7828 9.90386 22.5 10.2527 22.5C10.6015 22.5 10.8843 22.7828 10.8843 23.1316Z",
    fill: "#2D2943"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 6H27",
    stroke: "#2D2943",
    strokeWidth: 0.4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27 9L20 9",
    stroke: "#2D2943",
    strokeWidth: 0.4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18 12H27",
    stroke: "#2D2943",
    strokeWidth: 0.4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21 15L27 15",
    stroke: "#2D2943",
    strokeWidth: 0.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalInfo);
export default __webpack_public_path__ + "static/media/personal-info.644097a5.svg";
export { ForwardRef as ReactComponent };